// Test IDs for MoDuLerİS site — used by qabot testing agent.

export const SITE = {
  // Header
  logo: "site-logo",
  navHome: "nav-link-home",
  navAbout: "nav-link-about",
  navServices: "nav-link-services",
  navProjects: "nav-link-projects",
  navContact: "nav-link-contact",
  ctaHeader: "cta-header-quote",
  mobileMenuToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",

  // Hero
  heroTitle: "hero-title",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",

  // Values
  valueCard: (idx) => `value-card-${idx}`,

  // About
  aboutButton: "about-cta-button",

  // Services
  serviceCard: (idx) => `service-card-${idx}`,

  // Portfolio
  filterButton: (cat) => `filter-btn-${cat}`,
  projectCard: (id) => `project-card-${id}`,

  // Stats
  statValue: (idx) => `stat-value-${idx}`,

  // Contact form
  formName: "contact-form-name",
  formEmail: "contact-form-email",
  formPhone: "contact-form-phone",
  formService: "contact-form-service",
  formMessage: "contact-form-message",
  formSubmit: "contact-form-submit",
  formSuccess: "contact-form-success",
  formError: "contact-form-error",

  // Footer
  newsletterEmail: "newsletter-email",
  newsletterSubmit: "newsletter-submit",
  newsletterSuccess: "newsletter-success",
  socialLinkedin: "social-linkedin",
  socialInstagram: "social-instagram",
};
